module.exports = __webpack_public_path__ + "img/bb_g3_t_eyes-05.58c168b9.svg";